export default [
  {
    title: 'Dashboard',
    icon: 'AccountDashboard',
    link: 'AccountDashboard'
  },
  {
    title: 'Suscripciones',
    icon: 'Subscriptions',
    link: 'SubscriptionList',
    options: [
      {
        title: 'Facturas recurrentes',
        link: 'SubscriptionList'
      },
      {
        title: 'Productos',
        link: 'ProductListCreate'
      },
      {
        title: 'Complementos',
        link: 'AddonListCreate'
      },
      {
        title: 'Cupones de descuento',
        link: 'CouponListCreate'
      },
      {
        title: 'Gestionar'
      },
      {
        title: 'Registros de uso',
        link: 'UsageListCreate'
      },
      {
        title: 'Documentos de soporte',
        link: 'SupportingDocumentListCreate'
      }
    ]
  },
  {
    title: 'Facturación',
    icon: 'Invoicing',
    link: 'InvoiceList',
    options: [
      {
        title: 'Facturas',
        link: 'InvoiceList'
      },
      {
        title: 'Notas de crédito',
        link: 'CreditNoteList'
      },
      {
        title: 'Órdenes',
        link: 'OrderList'
      }
    ]
  },
  {
    title: 'Ingresos',
    icon: 'Revenue',
    link: 'PaymentListCreate',
    options: [
      {
        title: 'Pagos',
        link: 'PaymentListCreate'
      },
      {
        title: 'Transferencias',
        link: 'TransactionList'
      },
      {
        title: 'Cuentas por cobrar',
        link: 'Receivables'
      }
    ]
  },
  {
    title: 'Contactos',
    icon: 'Contacts',
    link: 'CustomerListCreate',
    options: [
      {
        title: 'Clientes',
        link: 'CustomerListCreate'
      },
      {
        title: 'Personas',
        link: 'ContactListCreate'
      }
    ]
  },
  {
    title: 'Componentes',
    icon: 'Components',
    link: 'Components'
  },
  {
    title: 'Reportes',
    icon: 'Reports',
    link: 'DashboardUpdate',
    options: [
      {
        title: 'Mis dashboards',
        isFreeComponent: true,
        component: 'DashboardDropDown'
      },
      {
        title: 'Colección de métricas',
        isFreeComponent: true,
        component: 'MetricsDropDown'
      }
      // {
      //   title: 'Explorador de dashboards',
      //   link: 'DefaultDashboardList'
      // },
      // {
      //   title: 'Favoritos',
      //   link: 'Favorites'
      // },
    ]
  },
  {
    title: 'Integraciones',
    icon: 'Integrations',
    link: 'Integrations',
    options: [
      {
        title: 'Documentos recibidos',
        description: '',
        link: 'PurchaseList'
      },
      {
        title: 'Facturas de compra',
        description: '',
        link: 'RetentionList',
        options: [
          {
            title: 'Lotes',
            description: '',
            link: 'RetentionBulkListCreate'
          }
        ]
      },
      {
        title: 'Proveedores',
        description: '',
        link: 'SupplierListCreate'
      }
    ]
  },
  {
    title: 'Configuración',
    description: '',
    link: 'AccountBasic',
    options: [
      {
        title: 'Cuenta',
        description: '',
        link: 'AccountBasic'
      },
      {
        title: 'Branding',
        description: '',
        link: 'AccountSettingsBranding'
      },
      {
        title: 'Facturación',
        description: '',
        link: 'AccountSettingsInvoicing'
      },
      {
        title: 'Pagos',
        description: '',
        link: 'AccountSettingsPayments'
      },
      {
        title: 'Banco',
        description: '',
        link: 'AccountSettingsBank'
      },
      {
        title: 'Correos electrónicos',
        description: '',
        link: 'AccountSettingsEmail'
      },
      {
        title: 'Webhooks',
        description: '',
        link: 'AccountSettingsWebhooksListCreate'
      },
      {
        title: 'Equipo',
        description: '',
        link: 'AccountMembers'
      },
      {
        title: 'Importar',
        description: '',
        link: 'AccountImports'
      },
      {
        title: 'Exportar',
        description: '',
        link: 'AccountExports'
      },
      {
        title: 'Facturación de Piriod',
        description: '',
        link: 'AccountBilling'
      }
    ]
  },
  {
    title: 'Agentes',
    icon: 'Agents',
    link: 'AgentList',
    options: [
      {
        title: 'Todos los agentes',
        link: 'AgentList'
      },
      {
        title: 'Feed',
        link: 'AgentInbox'
      },
      {
        title: 'Crear agente',
        link: 'AgentCreate'
      },
      {
        title: 'Recientes',
        isFreeComponent: true,
        component: 'AgentsDropDown'
      }
    ]
  }
]